//TODO stored models need to be lazy-loaded
import CartItemModel from '@/models/CartItemModel';
import CartOptionModel from '@/models/CartOptionModel';
import CartOptionChoiceModel from '@/models/CartOptionChoiceModel';
import ItemModel from '@/models/ItemModel';
import GroupModel from '@/models/GroupModel';
import BundleModel from '@/models/BundleModel';
import DiscountModel from '@/models/DiscountModel';
import OptionModel from '@/models/OptionModel';
import OptionExceptionModel from '@/models/OptionExceptionModel';
import MasterOptionExceptionModel from '@/models/MasterOptionExceptionModel';
import DefaultChoiceModel from '@/models/DefaultChoiceModel';
import OptionChoiceModel from '@/models/OptionChoiceModel';
import FreeChoiceSetModel, { FreeChoiceModel } from '@/models/FreeChoiceSetModel';
import CategoryModel from '@/models/CategoryModel';
import CategorySubModel, { SectionModel } from '@/models/CategorySubModel';
import CustomerModel from '@/models/CustomerModel';
import LocationModel from '@/models/LocationModel';
import OfferModel from '@/models/loyalty/OfferModel';
import DeliveryFlowModel from '@/models/DeliveryFlowModel';
var storedModels = {
    'CartItemModel': CartItemModel,
    'CartOptionModel': CartOptionModel,
    'CartOptionChoiceModel': CartOptionChoiceModel,
    'ItemModel': ItemModel,
    'BundleModel': BundleModel,
    'GroupModel': GroupModel,
    'DiscountModel': DiscountModel,
    'OptionModel': OptionModel,
    'OptionExceptionModel': OptionExceptionModel,
    'OptionChoiceModel': OptionChoiceModel,
    'FreeChoiceSetModel': FreeChoiceSetModel,
    'FreeChoiceModel': FreeChoiceModel,
    'CategoryModel': CategoryModel,
    'CategorySubModel': CategorySubModel,
    'SectionModel': SectionModel,
    'CustomerModel': CustomerModel,
    'LocationModel': LocationModel,
    'OfferModel': OfferModel,
    'DeliveryFlowModel': DeliveryFlowModel,
    "MasterOptionExceptionModel": MasterOptionExceptionModel,
    "DefaultChoiceModel": DefaultChoiceModel
};
export default storedModels;



//////////////////
// WEBPACK FOOTER
// ./src/models/StoredModels.ts
// module id = null
// module chunks = 